<div class="input-grid-gaps grid-1col">

    <div class="w-full flex flex-wrap align-items-center gap-2">
        <app-switch-input
            [disabled]="!store.isAllowed('user.update')()"
            [form]="commonForm" id="perService"
            label="acl.perService"
            (click)="onSwitchForms()"
        ></app-switch-input>
        @if (featureOn.PARENT_ORGANIZATION && !commonForm.value.perService && store.childOrganizations().length) {
            <app-button
                icon="pi-copy"
                label="acl.copyPermissionsToChildOrganizations"
                [disabled]="!store.isAllowed('user.update')()"
                [loading]="store.loadingAny()"
                (clickEvent)="copyPermissionsToChildOrganizations()"
            ></app-button>
        }
        @if (store.isAllowedGlobal('rule.update')()) {
<!--            <app-button-->
<!--                [label]="'user.fields.groups' | translate"-->
<!--                [text]="true"-->
<!--                (clickEvent)="editGroups()"-->
<!--            ></app-button>-->
        }
    </div>

    @if (!commonForm.value.perService) {
        <app-select-user-group
            [form]="form"
            [disabled]="!store.isAllowed('user.update')()"
        ></app-select-user-group>
        <app-select-user-rule
            [form]="form"
            [disabled]="!store.isAllowed('user.update')()"
        ></app-select-user-rule>
    } @else {
        <div class="flex flex-column gap-large">
            @for (form of serviceForms() |keyvalue; track form.key) {
                @if (!form.value.disabled) {
                    <div class="flex flex-column gap-small">
                        <div>{{ form.value.value.name }}</div>
                        <app-select-user-group
                            [form]="form.value"
                            [disabled]="form.value.disabled || !store.isAllowed('user.update')()"
                        ></app-select-user-group>
                        <app-select-user-rule
                            [form]="form.value"
                            [disabled]="form.value.disabled || !store.isAllowed('user.update')()"
                        ></app-select-user-rule>
                    </div>
                }
            }
        </div>
    }
</div>
